import React from 'react'
import SvgIcon from '@mui/material/SvgIcon'
import {
  FileCopy
} from '@mui/icons-material'

const fillC8 = { fill: '#c8c8c8' }
const fillRed = { fill: '#d65532' }

export const TemplateIcon = FileCopy

export const ContactIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <svg xmlns='http://www.w3.org/2000/svg' enableBackground='new 0 0 24 24' height='24' viewBox='0 0 24 24' width='24'>
        <rect fill='none' height='24' width='24' />
        <path d='M12,7V3H2v18h20V7H12z M10,19H4v-2h6V19z M10,15H4v-2h6V15z M10,11H4V9h6V11z M10,7H4V5h6V7z M20,19h-8V9h8V19z M18,11h-4v2 h4V11z M18,15h-4v2h4V15z' />
      </svg>
    </SvgIcon>
  )
}

export const ProjectIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <svg xmlns='http://www.w3.org/2000/svg' enableBackground='new 0 0 24 24' height='24' viewBox='0 0 24 24' width='24'>
        <g><rect fill='none' height='24' width='24' /></g>
        <g>
          <g>
            <path d='M20,3H4C2.9,3,2,3.9,2,5v14c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V5 C22,3.9,21.1,3,20,3z M20,19H4V5h16V19z' fillRule='evenodd' />
            <polygon fillRule='evenodd' points='19.41,10.42 17.99,9 14.82,12.17 13.41,10.75 12,12.16 14.82,15' />
            <rect fillRule='evenodd' height='2' width='5' x='5' y='7' />
            <rect fillRule='evenodd' height='2' width='5' x='5' y='11' />
            <rect fillRule='evenodd' height='2' width='5' x='5' y='15' />
          </g>
        </g>
      </svg>
    </SvgIcon>
  )
}

export const PdfFileIcon = (props) => {
  return (
    <SvgIcon viewBox='0 0 14 16' style={{ height: 16, width: 16 }} {...props}>
      <g id='pdf_-_16px' transform='translate(12379 16426)'>
        <path id='Path_75' fill='#fff' d='M45 45H35V31h8l2 2z' transform='translate(-12412 -16456)' />
        <path id='Path_76' fill='#a6a6a6' d='M43 30h-9v16h12V33zm0 1.5l1.5 1.5H43zM45 45H35V31h7v3h3z' transform='translate(-12412 -16456)' />
        <path id='Rectangle_169' d='M0 0H8V1H0z' style={fillC8} transform='translate(-12376 -16421)' />
        <path id='Rectangle_170' d='M0 0H8V1H0z' style={fillC8} transform='translate(-12376 -16419)' />
        <path id='Rectangle_171' d='M0 0H3V3H0z' style={fillRed} transform='translate(-12368 -16416)' />
        <path id='Rectangle_172' d='M0 0H3V3H0z' style={fillRed} transform='translate(-12379 -16416)' />
        <g id='Group_126' transform='translate(-12412 -16456)'>
          <path id='Path_77' d='M42 40v3h-4v-3h4m1-1h-6v5h6v-5z' style={fillRed} />
        </g>
        <path id='Rectangle_173' d='M0 0H3V1H0z' style={fillC8} transform='translate(-12376 -16424)' />
      </g>
    </SvgIcon>
  )
}
